import type { Prototype } from "../prototype-types";

export const oliviaOlearyPrototypes: Prototype[] = [
  {
    id: "image-enrichment-nudges",
    name: "Image Enrichment Nudges",
    path: "/oo/image-enrichment-nudges",
    description:
      "Brand homepage + products table nudges to review additional images found from the brand's site; dismissible vs persistent home card; bulk review stacked vs sidebar queue (Figma 283:32233).",
    owner: "Olivia",
    createdAt: "2026-03-19",
    lastUpdated: "2026-03-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3b77cbcf7ace3b1436fa6c43fa0fb1fe1dcd70be06dd84690e9eff4472091661.png",
    figmaLink:
      "https://www.figma.com/design/xSTkv2783T9dtAoBwlkOuG/Brand-Nudges-Strategy-H1-2026?node-id=283-32233&m=dev",
    creationTool: "cursor",
  },
  {
    id: "pdp-chat-missing-details",
    name: "PDP Chat Missing Details",
    path: "/oo/pdp-chat-missing-details",
    description:
      "My fork of PDP AI chat to explore nudging brands when there's missing info or details on the product.",
    owner: "Olivia OLeary",
    createdAt: "2026-03-17",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bf9735a98e341780cbfc195f6455c419a82c4e2e436547c4e7aa0c305b752175.png",
    creationTool: "cursor",
  },
  {
    id: "brand-nudges-missing-details-pdp-chat-messages",
    name: "Brand nudges for missing details (PDP Chat & Messages)",
    path: "/oo/brand-nudges-missing-details-pdp-chat-messages",
    description:
      "Nudging brands to add missing details from PDP chat and retailer messages.",
    owner: "Olivia OLeary",
    createdAt: "2026-03-17",
    lastUpdated: "2026-03-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/37b69cc3df49c23928c525d2be1681c3a1c1cf53015cee310ba9915473dd4ded.png",
    creationTool: "cursor",
  },
];
